import React from "react";
import "../styles/events.css";

export default function Events() {
  return (
    <div>
      <div className="ai-image"></div>

      <div className="events-text">
        <h1 className="events-title">Events</h1>

        <h2 className="events-link">
          <a href="https://sites.google.com/view/aaai23-ai4fintech">
            AAAI 2023 Summer Symposium on AI4FinTech
          </a>
        </h2>
      </div>
    </div>
  );
}
